import { Validators } from "@angular/forms";
import { filter, startWith, takeUntil } from 'rxjs';
import { ClaimControls, ClaimsForm } from "../form.controls";
import { CLAIMS_FORM_NAME, FormFactory } from "../form.factory";
import { Claim } from "../form.resources";
import { totalAmountValidator } from "../validators/total-amount";

export function getClaimsForm(this: FormFactory): ClaimsForm {
  const data = this.data as Claim[];

  const amountKey: keyof ClaimControls = 'original_amount';
  const currencyKey: keyof ClaimControls = 'currency_iso';

  const form = this.fb.array(
    data.map(claim => this.getClaimForm(claim)),
    [Validators.required, totalAmountValidator(amountKey, currencyKey, this.formService)],
  );

  this.formService.claimExchangeRates
    .pipe(takeUntil(this.formService.formChange))
    .subscribe(() => form.updateValueAndValidity());

  form.valueChanges
    .pipe(
      startWith(form.value),
      filter(claims => claims.length === 0),
    )
    .subscribe({
      next: () => form.push(this.getClaimForm())
    });

  form.statusChanges.subscribe(status => {
    if (status === 'VALID') {
      this.trackValidForm(CLAIMS_FORM_NAME);
    }
  });

  return form;
}
